import { Toaster as SonnerToaster } from 'sonner';

export const Toaster = () => (
  <SonnerToaster
    position="top-right"
    richColors
    toastOptions={{
      classNames: {
        toast: 'border border-border bg-card text-card-foreground',
        title: 'text-sm font-medium',
        description: 'text-xs text-muted-foreground',
        actionButton: 'bg-primary text-primary-foreground',
        cancelButton: 'bg-muted text-foreground',
      },
    }}
  />
);

